import React from 'react';
import ReactECharts from 'echarts-for-react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { getRiskLevel } from '../../data/helpers';

const { FiTrendingUp } = FiIcons;

const months = ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const RiskScoreChart = ({ learner }) => {
  const currentScore = learner.phishingRiskScore || 0;
  // Fallback to a flat line of current score if no real history exists, for visual consistency
  const history = [
    Math.max(0, currentScore - 15),
    Math.max(0, currentScore - 10),
    Math.max(0, currentScore - 5),
    Math.min(100, currentScore + 5),
    currentScore,
    currentScore
  ];
  
  const risk = getRiskLevel(currentScore);
  const color = currentScore < 20 ? '#10b981' : currentScore < 50 ? '#f59e0b' : '#ef4444';

  const option = {
    tooltip: { trigger: 'axis', formatter: 'Risk Score: {c}%' },
    grid: { left: '5%', right: '5%', top: '10%', bottom: '10%', containLabel: true },
    xAxis: { type: 'category', data: months, axisLabel: { fontSize: 10 }, axisLine: { show: false }, axisTick: { show: false } },
    yAxis: { type: 'value', min: 0, max: 100, splitLine: { lineStyle: { color: '#f1f5f9' } }, axisLabel: { fontSize: 10 } },
    series: [{
      type: 'line', data: history, smooth: true,
      itemStyle: { color },
      lineStyle: { color, width: 2.5 },
      areaStyle: { color: `${color}18` },
      symbol: 'circle', symbolSize: 6,
    }]
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <h3 className="text-sm font-semibold text-slate-700 mb-1 flex items-center gap-2">
        <SafeIcon icon={FiTrendingUp} className="text-violet-500" /> Risk Score History
      </h3>
      <div className="flex items-center gap-2 mb-4">
        <span className={`text-2xl font-bold`} style={{ color }}>{currentScore}%</span>
        <span className={`px-2 py-0.5 rounded-full text-xs font-semibold border ${risk.color}`}>{risk.label} Risk</span>
      </div>
      <ReactECharts option={option} style={{ height: 160 }} />
    </div>
  );
};

export default RiskScoreChart;